import React from 'react';
import {Row, Col} from 'react-bootstrap';
import {Doughnut} from '../react-chartjsx/src';

import Auxiliary from '../../hoc/Auxiliary/Auxiliary';

import './Cluster.css';

import happy from '../../assets/Happy_Smiley.png';
import sad from '../../assets/Sad_Smiley.png';
import neutral from '../../assets/Neutral_Smiley.png';
//import logo from '../../assets/Total_Logo.png';

const clusterDetail = (props) => {
    let positivePrecentage = 0.0;
    
    // Dougnut Parameters
    let doughnutData = {
        datasets: [{
            data: [0, 0, 0],
            /*borderColor: [
                "rgba(238, 41, 48, 0.4)",
                "rgba(245, 238, 52, 0.4)",
                "rgba(71, 183, 73, 0.4)",
            ],
            backgroundColor: [
                "rgba(238, 41, 48, 1.0)",
                "rgba(245, 238, 52, 1.0)",
                "rgba(71, 183, 73, 1.0)",
            ],
            hoverBorderColor: [
                "white",
                "white",
                "white",
            ],
            hiverBackgroundColor: [
                "rgba(238, 41, 48, 1.0)",
                "rgba(245, 238, 52, 1.0)",
                "rgba(71, 183, 73, 1.0)",
            ],*/
            borderWidth: 0,
            hoverBorderWidth: 1,
            backgroundColor: [
            '#EE2930',
            '#F5EE34',
            '#47B749'
            ],
            hoverBackgroundColor: [
            '#EE2930',
            '#F5EE34',
            '#47B749'
            ]
        }],
        labels: ['Sad', 'Neutral', 'Happy']
    };

    // const doughnutPlugins = [{
    //     afterDraw: (chartInstance, easing) => {
    //         const ctx = chartInstance.chart.ctx;
    //         const x = chartInstance.width / 2 - 20;
    //         const y = chartInstance.height / 2;

    //         ctx.font = 'bold 20px Arial';
    //         ctx.fillText(positivePrecentage.toFixed(0) + '%', x, y);
    //         ctx.font = 'normal 10px Arial';
    //         ctx.fillText('Positive', x, y + 15);
    //     }
    // }];

    const doughnutOptions = {
        maintainAspectRatio: true,
        legend: {
            display: false
        },
        cutoutPercentage: 75,
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    let label = data.labels[tooltipItem.index] || '';
                    let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                    if (label) {
                        label += ': ';
                    }
                    label += value.toFixed(0);
                    return label;
                }
            }
        }
    }

    const doughnutEvent = (e) => {
        //alert(e)
    }

    const onPanelClick = (e) => {
        props.onClicked(props.clusterIndex);
    }

    // Populate data
    let stats = {
        aButtonPresses: 0,
        bButtonPresses: 0,
        cButtonPresses: 0,
        dButtonPresses: 0,
        eButtonPresses: 0
    };
    if (props.cluster !== undefined){
        for(let i = 0; i < props.cluster.devices.length; i++){
            if (props.cluster.devices[i].stats !== undefined){
                stats.aButtonPresses += props.cluster.devices[i].stats.aButtonPresses;
                stats.bButtonPresses += props.cluster.devices[i].stats.bButtonPresses;
                stats.cButtonPresses += props.cluster.devices[i].stats.cButtonPresses;
                stats.dButtonPresses += props.cluster.devices[i].stats.dButtonPresses;
                stats.eButtonPresses += props.cluster.devices[i].stats.eButtonPresses;    
            }
        }    
    }
    const total = stats.aButtonPresses + stats.bButtonPresses + stats.cButtonPresses + 
        stats.dButtonPresses + stats.eButtonPresses;
    
    if (total > 0){
        positivePrecentage = (stats.aButtonPresses + stats.bButtonPresses + stats.cButtonPresses) / 
        total * 100;
    }
    else
        positivePrecentage = 0;
    
    // Set dougnut data
    doughnutData.datasets[0].data[2] = stats.aButtonPresses / total * 100;
    doughnutData.datasets[0].data[1] = stats.cButtonPresses / total * 100;
    doughnutData.datasets[0].data[0] = stats.eButtonPresses / total * 100;

    // Get logo
    let logo = null;
    if (props.cluster.uiConfig != null){
        try{
            const uiConfig = JSON.parse(props.cluster.uiConfig);

            if (uiConfig.buzzCSA){
                if (uiConfig.buzzCSA.logo){
                    logo = uiConfig.buzzCSA.logo;
                }
            }
        }
        catch(err) {
            console.log(err);
        }
    }
    
    return (
        <Auxiliary>
            <Row>
                <Col xs={7}>
                    <div className='ClusterPanel' onClick={onPanelClick}>
                        <div className='ClusterSummaryHeading'>OVERALL DISTRIBUTION</div>
                        <Col xs={4}>
                            {total > 0 ? 
                                <div>
                                    <div className='ClusterDoughnutValue'>{positivePrecentage.toFixed(0)}%</div>
                                    <div className='ClusterDoughnutLabel'>Positive</div>
                                </div> 
                            : 
                                <div className='ClusterDoughnutValue'>N/A</div>
                            }
                            {/*<div className='ClusterDoughnut'>*/}
                                <Doughnut 
                                    data={doughnutData}
                                    width={100}
                                    height={100} 
                                    options={doughnutOptions}
                                    //plugins={doughnutPlugins}
                                    onElementsClick={doughnutEvent}
                                />
                            {/*</div>*/}
                        </Col>
                        <Col xs={2}>
                            <img src={happy} alt='Happy' className='ClusterSummaryImage'/>
                            <div className='ClusterSummaryPercentage'>{total > 0 ? (stats.aButtonPresses / total * 100).toFixed(0) : 0}%</div>
                            <div className='ClusterSummaryCount'>{stats.aButtonPresses}</div>
                        </Col>
                        <Col xs={2}>
                            <img src={neutral} alt='Neutral' className='ClusterSummaryImage'/>
                            <div className='ClusterSummaryPercentage'>{total > 0 ? (stats.cButtonPresses / total * 100).toFixed(0) : 0}%</div>
                            <div className='ClusterSummaryCount'>{stats.cButtonPresses}</div>
                        </Col>
                        <Col xs={2}>
                            <img src={sad} alt='Sad' className='ClusterSummaryImage'/>
                            <div className='ClusterSummaryPercentage'>{total > 0 ? (stats.eButtonPresses / total * 100).toFixed(0) : 0}%</div>
                            <div className='ClusterSummaryCount'>{stats.eButtonPresses}</div>
                        </Col>
                        <div className='ClusterSummaryResponse'>{total + ' Responses'}</div>
                    </div>
                </Col>
                <Col xs={5}>
                    {logo !== null ? 
                        <img className='ClusterLogo' src={logo} alt='Logo' title='Logo'/>
                    :
                        null
                    }
                </Col>
            </Row>
        </Auxiliary>
    );
};

export default clusterDetail;